import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_TRIAL_INSTITUTION_ID,
    ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_ID,

    ACTION_TRIALINSTITUTIONFINANCE_SAVE,

    ACTION_TRIALINSTITUTIONFINANCE_CREATE,

    ACTION_TRIALINSTITUTIONFINANCE_VALIDATE,

    ITrialInstitutionFinanceLoadByTrialInstitutionIdAction,
    ITrialInstitutionFinanceLoadByIdAction,
    ITrialInstitutionFinanceLoadFailureAction,
    ITrialInstitutionFinanceLoadSuccessAction,

    ITrialInstitutionFinanceSaveAction,
    ITrialInstitutionFinanceSaveSuccessAction,
    ITrialInstitutionFinanceSaveFailureAction,

    ITrialInstitutionFinanceCreateAction,
    ITrialInstitutionFinanceCreateSuccessAction,
    ITrialInstitutionFinanceCreateFailureAction,

    ITrialInstitutionFinanceValidateAction,
    ITrialInstitutionFinanceValidateSuccessAction,
    ITrialInstitutionFinanceValidateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

    ValidateSuccess,
    ValidateFailure,

} from "../actions/trialInstitutionFinance";
import { trialInstitutionFinanceApi } from "../services/trialInstitutionFinance";

export const
    getTrialInstitutionFinanceByTrialInstitutionIdEpic = (action$): Observable<ITrialInstitutionFinanceLoadSuccessAction | ITrialInstitutionFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_TRIAL_INSTITUTION_ID)
            .mergeMap((action: ITrialInstitutionFinanceLoadByTrialInstitutionIdAction) => {
                return trialInstitutionFinanceApi
                    .getTrialInstitutionFinanceByTrialInstitutionId(action.trialInstitutionId)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getTrialInstitutionFinanceByIdEpic = (action$): Observable<ITrialInstitutionFinanceLoadSuccessAction | ITrialInstitutionFinanceLoadFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONFINANCE_LOAD_BY_ID)
            .mergeMap((action: ITrialInstitutionFinanceLoadByIdAction) => {
                return trialInstitutionFinanceApi
                    .getTrialInstitutionFinanceById(action.id)
                    .map(response =>
                        LoadSuccess(response.trialInstitutionFinance, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setTrialInstitutionFinanceEpic = (action$): Observable<ITrialInstitutionFinanceSaveSuccessAction | ITrialInstitutionFinanceSaveFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONFINANCE_SAVE)
            .mergeMap((action: ITrialInstitutionFinanceSaveAction) => {
                return trialInstitutionFinanceApi
                    .setTrialInstitutionFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.trialInstitutionFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createTrialInstitutionFinanceEpic = (action$): Observable<ITrialInstitutionFinanceCreateSuccessAction | ITrialInstitutionFinanceCreateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONFINANCE_CREATE)
            .mergeMap((action: ITrialInstitutionFinanceCreateAction) => {
                return trialInstitutionFinanceApi
                    .createTrialInstitutionFinance(action.trialInstitutionId)
                    .map(response =>
                        CreateSuccess(
                            response.trialInstitutionFinance,
                            response.formState,
                            response.formProperties,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateTrialInstitutionFinanceEpic = (action$): Observable<ITrialInstitutionFinanceValidateSuccessAction | ITrialInstitutionFinanceValidateFailureAction> => {
        return action$
            .ofType(ACTION_TRIALINSTITUTIONFINANCE_VALIDATE)
            .mergeMap((action: ITrialInstitutionFinanceValidateAction) => {
                return trialInstitutionFinanceApi
                    .validateTrialInstitutionFinance(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.trialInstitutionFinance, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }